import { PositionedToggle, type ToggleProps } from '@carboncopyco/ui';
import classNames from 'classnames';

export type RuleCardToggleProps = Pick<
  ToggleProps,
  'checked' | 'onChange' | 'testId'
> & {
  cardOpen?: boolean;
};

export const RuleCardToggle = ({
  checked,
  onChange,
  cardOpen,
  testId,
}: RuleCardToggleProps) => {
  return (
    <div
      className={classNames(
        cardOpen ? 'hidden' : 'opacity-0 group-hover:opacity-100'
      )}
      data-testid={testId}
      onClick={(event) => event.stopPropagation()}
    >
      <PositionedToggle
        checked={checked}
        onChange={onChange}
      />
    </div>
  );
};
